module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNGf81d1249f53cdad108162a07979d4009.f81d1249.png";